module.exports = __webpack_public_path__ + "media/images/post/icon_sns_tw-460c02cccbb5d23d5fe0c528df1e74a0.png";